var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    clipPath: "url(#clip0_4222_217128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.233 2.25c-3.848 0-6.983 3.135-6.983 6.983s3.135 6.982 6.983 6.982 6.982-3.135 6.982-6.982S13.08 2.25 9.233 2.25m0 12.698a5.723 5.723 0 0 1-5.716-5.716 5.723 5.723 0 0 1 5.716-5.714 5.723 5.723 0 0 1 5.714 5.715 5.723 5.723 0 0 1-5.714 5.714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.754 9.577-.16-2.38A18 18 0 0 1 8.55 6.2q0-.412.214-.64a.75.75 0 0 1 .57-.234q.428 0 .572.298.144.294.144.85 0 .327-.035.665l-.213 2.449q-.035.437-.15.67a.39.39 0 0 1-.377.234q-.269 0-.372-.224-.105-.228-.15-.69m.551 3.268a.8.8 0 0 1-.531-.194q-.224-.198-.224-.551a.7.7 0 0 1 .214-.521.72.72 0 0 1 .531-.219q.313 0 .532.219a.7.7 0 0 1 .223.521q0 .348-.223.546a.76.76 0 0 1-.522.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4222_217128"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.25 2.25h13.965v13.965H2.25z"
  })))));
};
export default SvgAttention;